import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

const mapState = ({ queryParams }: AnyAction) => ({
  originalQueryKey: queryParams.originalQueryKey,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
